import React, { useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ReactList from "react-list";
import { useDispatch, useSelector } from "react-redux";
import { selectUtilityState } from "../../../features/utilities/utilitySlice";
import { selectGlobalDataState } from "../../../features/global/globalDataSlice";
import { sendGeneralRequest } from "../../../features/generalRequest";
import colors from "../../colors";
import Divider from "@mui/material/Divider";
import { texts } from "../../general/texts";

const EventsAndPartners = ({ isEvent }) => {

    const useStyles = makeStyles({
        scrollBar: {
          "&::-webkit-scrollbar": {
            width: "10px",
            height: "50%",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#FFFFFF",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "linear-gradient(to bottom, #EF7A30, #F0A13D)",
            borderRadius: "10px",
            maxHeight: "50%",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "linear-gradient(to bottom, #EF7A30, #F0A13D)",
          },
        },
        scrollBarStack: {
          "&::-webkit-scrollbar": {
            width: "50%",
            height: "5px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#FFFFFF",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: colors.lightGray,
            borderRadius: "10px",
            maxWidth: "50%",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: colors.lightGray,
          },
        },
      });
    const classes = useStyles();
    const dispatch = useDispatch();
    const utilityState = useSelector(selectUtilityState);
    const globalDataSliceState = useSelector(selectGlobalDataState);

    useEffect(() => {
        if (isEvent) {
        !utilityState.events &&
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token }, baseUrlKey: "services", endpoint: "GetTicketEvents" }));
        } else {
        !utilityState.partners &&
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token }, baseUrlKey: "services", endpoint: "GetPartners" }));
        }
    }, [isEvent]);

    return (
      <>
        <div
            style={{ overflow: (isEvent ? (utilityState.events && utilityState.events.length) : (utilityState.partners && utilityState.partners.length)) > 4 ? "auto" : "hidden",
            maxHeight: "50vh", paddingTop: "3%" }}className={classes.scrollBar}>
           
                <ReactList
                itemRenderer={(idx, key) => (
                    <a href={isEvent ? utilityState.events[idx].eventUrl : utilityState.partners[idx].merchantUrl}
                    key={key}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                    >
                    <Grid item md={12} xs={12}>
                        <Grid container item md={12} xs={12} mr={100} spacing={1.5} my={"1%"} padding={"1%"} flexDirection={{ xs: "column", md: "row" }} sx={{ ":hover": { background: colors.lightOrange } }}>
                        <Grid container flexDirection={"column"} justifyContent={"center"} item xs={3} md={2}>
                            <img width={150} src={isEvent ? utilityState.events[idx].imagePath : utilityState.partners[idx].imagePath} />
                        </Grid>
                        <Grid container item md={10} xs={9} spacing={1} sx={{ "@media (max-width: 1220px)": { pl: "20%" } }}>
                            <Grid container item justifyContent={"flex-start"} md={12}>
                            <Typography sx={{ fontFamily: "GerberaBold", color: colors.darkBlue }}>
                                {isEvent ? utilityState.events[idx].eventName : utilityState.partners[idx].name}
                            </Typography>
                            </Grid>
                            <Grid container item md={12} xs={12}>
                            <Grid container item md={8} xs={8} justifyContent={"flex-start"}>
                                <Typography sx={{ color: colors.gray, fontFamily: "GerberaLight", fontSize: "0.8rem" }}>
                                {isEvent ? texts["placeholder-expiry-date"] + ": " + utilityState.events[idx].expireDate : utilityState.partners[idx].description}
                                </Typography>
                            </Grid>
                            </Grid>
                        </Grid>
                        </Grid>
                        <Grid item md={12} xs={12}>
                        <Divider sx={{ borderWidth: 0.5 }} />
                        </Grid>
                    </Grid>
                    </a>
                )}
                type="uniform"
                length={isEvent ? (utilityState.events && utilityState.events.length) : (utilityState.partners && utilityState.partners.length)}
                />
         
        </div>
      </>
    );
};

export default EventsAndPartners;
